<template>
    <EditorPreferencesTabs :features="features" tab-key="miscellaneous">
        <div class="mb-[98px] mt-[44px]">
            <TestingEmailsSettings
                v-if="globalProps.team.personal_team"
                class="border-b border-gray-300"
                :model-value="editorSettings.testing_emails"
                @update:modelValue="updateTestingEmails"
            />

            <HtmlMinifiedSettings
                class="border-b border-gray-300"
                :model-value="editorSettings.html_minified"
                @update:modelValue="updateHtmlMinified"
            />

            <CustomStatusesSettings
                :model-value="
                    globalProps.team?.editor_settings?.custom_statuses ?? []
                "
                @update:modelValue="updateCustomStatuses"
            />
        </div>
    </EditorPreferencesTabs>
</template>

<script lang="ts" setup>
import { route } from 'ziggy-js';
import { PropType } from 'vue';
import IEditorSettings from '@/types/Settings/IEditorSettings';
import EditorPreferencesTabs from '../components/EditorPreferencesTabs.vue';
import { create } from '@composables/useNotifications';
import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';

defineProps({
    editorSettings: {
        type: Object as PropType<IEditorSettings>,

        default: () => {},
    },
    features: {
        type: Object,
        default: null,
    },
});

const globalProps = computed(() => usePage<ITopolPageProps>().props);

const updateHtmlMinified = (value: boolean) => {
    router.put(
        route('editor-preferences.html-minified.update'),
        {
            html_minified: value,
        },
        {
            preserveScroll: true,
            onSuccess: () => {
                create({
                    title: 'Minify HTML settings updated',
                    type: 'success',
                });
            },
            onError: () => {
                create({
                    title: 'Minify HTML settings not updated',
                    text: 'There was an error updating your minify HTML settings.',
                    type: 'error',
                });
            },
        }
    );
};

const updateTestingEmails = (emails: string[]) => {
    router.put(
        route('editor-preferences.testing-emails.update'),
        {
            emails: emails,
        },
        {
            preserveScroll: true,
            onSuccess: () => {
                create({
                    title: 'Testing emails updated',
                    type: 'success',
                });
            },
            onError: () => {
                create({
                    title: 'Testing emails not updated',
                    text: 'There was an error updating your testing emails.',
                    type: 'error',
                });
            },
        }
    );
};

const updateCustomStatuses = (statuses: string[]) => {
    router.put(
        route('settings.custom-statuses.update'),
        {
            statuses: statuses,
        },
        {
            preserveScroll: true,
            onSuccess: () => {
                create({
                    title: 'Custom statuses updated',
                    type: 'success',
                });
            },
            onError: () => {
                create({
                    title: 'Custom statuses not updated',
                    text: 'There was an error updating your custom statuses.',
                    type: 'error',
                });
            },
        }
    );
};
</script>

<style></style>
